// src/utils/cotizacionValidation.ts
import type { CotizacionData } from '../types/cotizacionFormTypes'
import { getMeta } from './cotizacionFormUtils'

/**
 * Valida el formulario de cotización
 * @param formData - Datos del formulario
 * @param mode - Modo del formulario ('create' | 'edit' | 'view')
 * @returns Objeto con errores encontrados
 */
export function validateCotizacionForm(
  formData: CotizacionData,
  mode: 'view' | 'edit' | 'create'
): { [key: string]: string } {
  const errors: { [key: string]: string } = {}

  // Validaciones de información general
  if (!formData.status) {
    errors.status = 'El estado es obligatorio'
  }

  // Validaciones de cliente
  if (!formData.billingAddress?.first_name) {
    errors.first_name = 'El nombre es obligatorio'
  }
  if (!formData.billingAddress?.last_name) {
    errors.last_name = 'El apellido es obligatorio'
  }
  if (!formData.customer?.email) {
    errors.email = 'El email es obligatorio'
  } else if (formData.customer.email.toLowerCase().endsWith('.con')) {
    errors.email = 'El dominio .con no es válido. Por favor, use un dominio válido como .com, .co, etc.'
  }
  if (!getMeta(formData.meta_data || [], 'tipo_documento')) {
    errors.tipo_documento = 'El tipo de documento es obligatorio'
  }
  if (!getMeta(formData.meta_data || [], 'documento')) {
    errors.documento = 'El documento es obligatorio'
  }
  if (!formData.billingAddress?.phone && !formData.phone) {
    errors.phone = 'El teléfono es obligatorio'
  }

  // Validaciones de dirección de facturación
  if (!formData.billingAddress?.address_1) {
    errors.billing_address = 'La dirección de facturación es obligatoria'
  }
  if (!formData.billingAddress?.state) {
    errors.billing_state = 'El departamento de facturación es obligatorio'
  }
  if (!formData.billingAddress?.city) {
    errors.billing_city = 'La ciudad de facturación es obligatoria'
  }

  // Validaciones de dirección de envío
  if (!formData.shippingAddress?.address_1) {
    errors.shipping_address = 'La dirección de envío es obligatoria'
  }
  if (!formData.shippingAddress?.state) {
    errors.shipping_state = 'El departamento de envío es obligatorio'
  }
  if (!formData.shippingAddress?.city) {
    errors.shipping_city = 'La ciudad de envío es obligatoria'
  }

  // Validaciones de productos
  if (!formData.line_items?.length) {
    errors.line_items = 'Debe agregar al menos un producto'
  }

  // Validaciones específicas para modo create
  if (mode === 'create') {
    if (!getMeta(formData.meta_data || [], 'expiration_limit')) {
      errors.expiration_limit = 'La vigencia es obligatoria'
    }
  }

  return errors
}

